module.exports = __webpack_public_path__ + "img/0499e6_a20e9ed0537b4d8cb889380f3f5c81bd_mv2.cca35043.webp";